import { Snackbar, Alert, AlertTitle } from '@mui/material';
import { formatMessage } from 'src/i18n/intl';
import Locale from 'src/i18n';

const RemoveFileSuccessful = ({ handleRemoveFileSuccess }) => {
    return (
        <Snackbar
            open
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            autoHideDuration={5000}
            disableWindowBlurListener
            onClose={handleRemoveFileSuccess}>
            <div>
                <Alert
                    severity="success"
                    contrast="normal"
                    width="toast"
                    onClose={handleRemoveFileSuccess}
                    title={formatMessage(Locale.success)}>
                    <AlertTitle>{formatMessage(Locale.success)}</AlertTitle>
                    {formatMessage(Locale.bulkImportRemoveFileSucess)}
                </Alert>
            </div>
        </Snackbar>
    );
};

export default RemoveFileSuccessful;
